// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"448ae3c2","239":"e39fb35b","316":"518abb6e","455":"c1b198d4","904":"deb5acd4"}[chunkId] + ".chunk.js";
};